import { Link } from '@chakra-ui/react';
import React from 'react';

import type { FormFields } from '../types';

import { useI18n } from 'lib/i18n/context';
import FormFieldText from 'ui/shared/forms/fields/FormFieldText';

import ContractVerificationFormRow from '../ContractVerificationFormRow';
import { CONTRACT_VERIFICATION_FIELD_KEYS } from '../i18n';

const ContractVerificationFieldConstructorArgs = () => {
  const { t } = useI18n();
  return (
    <ContractVerificationFormRow>
      <FormFieldText<FormFields>
        name="constructor_args"
        isRequired
        rules={{ maxLength: 255 }}
        placeholder={ t(CONTRACT_VERIFICATION_FIELD_KEYS.constructorArgs.placeholder) }
        size={{ base: 'md', lg: 'lg' }}
        asComponent="Textarea"
      />
      <>
        <span>{ t(CONTRACT_VERIFICATION_FIELD_KEYS.constructorArgs.descriptionPart1) } </span>
        <Link href="https://solidity.readthedocs.io/en/develop/abi-spec.html" target="_blank">
          { t(CONTRACT_VERIFICATION_FIELD_KEYS.constructorArgs.abiHexLink) }
        </Link>
        <span> { t(CONTRACT_VERIFICATION_FIELD_KEYS.constructorArgs.descriptionPart2) }</span>
        <span> { t(CONTRACT_VERIFICATION_FIELD_KEYS.constructorArgs.descriptionPart3) } </span>
        <Link href="https://abi.hashex.org/" target="_blank">{ t(CONTRACT_VERIFICATION_FIELD_KEYS.constructorArgs.parsedHereLink) }</Link>
        <span>.</span>
      </>
    </ContractVerificationFormRow>
  );
};

export default React.memo(ContractVerificationFieldConstructorArgs);
